import { AoIndexering, AoUitkering, GedeeltelijkeUitkeringAoOpties } from "../../.generated/forms/formstypes";
import { createMapToDl } from "../../shared/utils/create-map-to-dl";
import { createMapToUi } from "../../shared/utils/create-map-to-ui";
import {
  AoIndexeringenType,
  AoUitkeringswijze,
  specificatieAoUitkeringModalSchema
} from "./specificatie-ao-uitkering-schema";

function mapAoIndexeringenUi2Dl(
  indexeringen: undefined,
  gedeeltelijkeUitkeringObv: GedeeltelijkeUitkeringAoOpties
): null;
function mapAoIndexeringenUi2Dl(
  indexeringen: AoIndexeringenType[],
  gedeeltelijkeUitkeringObv: GedeeltelijkeUitkeringAoOpties
): AoIndexering[] | null;
function mapAoIndexeringenUi2Dl(
  indexeringen?: AoIndexeringenType[],
  gedeeltelijkeUitkeringObv?: GedeeltelijkeUitkeringAoOpties
): AoIndexering[] | null {
  if (!indexeringen) return null;
  if (indexeringen.length === 0) return null;
  return indexeringen.map(
    (x: AoIndexeringenType, index: number): AoIndexering => {
      const isValidUitkeringsPercentage =
        x.uitkeringPercentage !== null && typeof x.uitkeringPercentage === "number" && !isNaN(x.uitkeringPercentage);
      const uitkeringsPercentageAsNumber = isValidUitkeringsPercentage ? Number(x.uitkeringPercentage) : 0;
      const uitkeringsPercentage =
        (isValidUitkeringsPercentage &&
          gedeeltelijkeUitkeringObv === GedeeltelijkeUitkeringAoOpties.Staffel &&
          uitkeringsPercentageAsNumber >= 0) ||
        (isValidUitkeringsPercentage &&
          gedeeltelijkeUitkeringObv !== GedeeltelijkeUitkeringAoOpties.Staffel &&
          uitkeringsPercentageAsNumber > 0)
          ? uitkeringsPercentageAsNumber
          : null;
      return {
        bovengrensPercentage: x.bovengrensPercentage,
        ondergrensPercentage: x.ondergrensPercentage,
        uitkeringPercentage: uitkeringsPercentage,

        volgnummer: index + 1
      };
    }
  );
}

function mappedIndexeringDl2Ui(
  aoIndexeringen: AoIndexering[] | null,
  gedeeltelijkeUitkeringObv: GedeeltelijkeUitkeringAoOpties | null
): AoIndexeringenType[] | null {
  return aoIndexeringen
    ? aoIndexeringen.map(
        (x: AoIndexering): AoIndexeringenType => ({
          bovengrensPercentage: x.bovengrensPercentage ?? null,
          ondergrensPercentage: x.ondergrensPercentage ?? null,
          uitkeringPercentage:
            gedeeltelijkeUitkeringObv === GedeeltelijkeUitkeringAoOpties.Staffel
              ? x.uitkeringPercentage ?? 0
              : x.uitkeringPercentage,
          error: false
        })
      )
    : specificatieAoUitkeringModalSchema.default().indexeringen;
}

export const mapSpecificatieAoUitkeringModalUi2Dl = createMapToDl(specificatieAoUitkeringModalSchema)
  .with<AoUitkeringswijze | null>()
  .to<AoUitkering>({
    aoIndexeringen: v => mapAoIndexeringenUi2Dl(v.indexeringen, v.gedeeltelijkeUitkeringObv),
    gedeeltelijkeUitkeringObv: (v, context) =>
      context === AoUitkeringswijze.ProRata ? v.gedeeltelijkeUitkeringObv : null,
    minimaalAoPercentage: (v, context) =>
      context === AoUitkeringswijze.ProRata ? v.proRataMinPercentage : v.volledigMinPercentage,
    rvcAfwijkingCode: v => v.afwijkendRestverdien,
    rvcAfwijkingPercentage: v => (v.afwijkendToggle ? v.afwijkendRestverdienPercentage : null),
    rvcUitkeringPercentage: v => v.afwijkendUitkeringspercentage,
    totAoPercentage: (v, context) =>
      context === AoUitkeringswijze.ProRata ? v.proRataTotPercentage : v.volledigVanafPercentage,
    isAfwijkendBijRestVerdienCapaciteit: v => v.afwijkendToggle
  });

export const mapSpecificatieAoUitkeringModalDl2Ui = createMapToUi(specificatieAoUitkeringModalSchema).from<AoUitkering>(
  {
    afwijkendRestverdien: v =>
      v.rvcAfwijkingCode ? v.rvcAfwijkingCode : specificatieAoUitkeringModalSchema.default().afwijkendRestverdien,
    afwijkendRestverdienPercentage: v =>
      v.rvcAfwijkingPercentage || specificatieAoUitkeringModalSchema.default().afwijkendRestverdienPercentage,
    gedeeltelijkeUitkeringObv: v =>
      v.gedeeltelijkeUitkeringObv
        ? v.gedeeltelijkeUitkeringObv
        : specificatieAoUitkeringModalSchema.default().gedeeltelijkeUitkeringObv,
    afwijkendToggle: v => v.isAfwijkendBijRestVerdienCapaciteit,
    afwijkendUitkeringspercentage: v =>
      v.rvcUitkeringPercentage || specificatieAoUitkeringModalSchema.default().afwijkendUitkeringspercentage,
    indexeringen: v => mappedIndexeringDl2Ui(v.aoIndexeringen, v.gedeeltelijkeUitkeringObv),
    proRataMinPercentage: v =>
      v.minimaalAoPercentage || specificatieAoUitkeringModalSchema.default().proRataMinPercentage,
    proRataTotPercentage: v => v.totAoPercentage || specificatieAoUitkeringModalSchema.default().proRataTotPercentage,
    volledigMinPercentage: v =>
      v.minimaalAoPercentage || specificatieAoUitkeringModalSchema.default().volledigMinPercentage,
    volledigVanafPercentage: v =>
      v.totAoPercentage || specificatieAoUitkeringModalSchema.default().volledigVanafPercentage
  }
);
